import { Container, Graphics, Text, TextStyle } from 'pixi.js';
import { COLORS } from '../config/Colors';

export class Notification extends Container {
  private background: Graphics;
  private messageText: Text;
  private isShowing: boolean = false;
  
  constructor() {
    super();
    
    this.background = new Graphics();
    this.addChild(this.background);
    
    const style = new TextStyle({
      fontFamily: 'Spenbeb, Georgia, serif',
      fontSize: 24,
      fontWeight: 'bold',
      fill: 0xFFFFFF,
      stroke: { color: 0x000000, width: 3 },
      wordWrap: true,
      wordWrapWidth: 600,
      align: 'center'
    });
    
    this.messageText = new Text({ text: '', style });
    this.messageText.anchor.set(0.5);
    this.addChild(this.messageText);
    
    this.visible = false;
    this.zIndex = 200;
  }
  
  public show(message: string, duration: number = 2000): void {
    if (this.isShowing) return;
    
    this.isShowing = true;
    this.messageText.text = message;
    
    // Calculate background size based on text
    const textWidth = this.messageText.width + 40;
    const textHeight = this.messageText.height + 20;
    
    // Draw background
    this.background.clear();
    this.background.roundRect(-textWidth/2, -textHeight/2, textWidth, textHeight, 10);
    this.background.fill({ color: 0xC62828, alpha: 0.95 });
    this.background.stroke({ color: 0xFFFFFF, width: 3 });
    
    // Position at top of screen
    this.x = 0;
    this.y = -400;
    
    this.visible = true;
    this.alpha = 0;
    
    // Fade in
    const fadeInDuration = 200;
    const startTime = Date.now();
    
    const fadeIn = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / fadeInDuration, 1);
      this.alpha = progress;
      
      if (progress < 1) {
        requestAnimationFrame(fadeIn);
      }
    };
    
    fadeIn();
    
    // Auto hide after duration
    setTimeout(() => {
      this.hide();
    }, duration);
  }
  
  private hide(): void {
    const fadeOutDuration = 200;
    const startTime = Date.now();
    
    const fadeOut = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / fadeOutDuration, 1);
      this.alpha = 1 - progress;
      
      if (progress < 1) {
        requestAnimationFrame(fadeOut);
      } else {
        this.visible = false;
        this.isShowing = false;
      }
    };
    
    fadeOut();
  }
  
  public showInsufficientBalance(): void {
    this.show('⚠️ Insufficient Balance!', 3000);
  }
  
  public showWin(amount: number): void {
    const prefix = amount >= 500 ? '🎉 BIG WIN!' : '✨ WIN!';
    this.show(`${prefix} ${amount.toLocaleString()}`, 2500);
  }
}